module.exports = __webpack_public_path__ + "static/media/portbg.76326b34.png";